interface TechIcon {
  path: string;
  name: string;
}

const techIcons: { [key: string]: TechIcon } = {
  // Programming Languages
  'Python': {
    path: '/icons/python.svg',
    name: 'Python'
  },
  'JavaScript': {
    path: '/icons/javascript.svg',
    name: 'JavaScript'
  },
  'TypeScript': {
    path: '/icons/typescript.svg',
    name: 'TypeScript'
  },
  'Java': {
    path: '/icons/java.svg',
    name: 'Java'
  },

  // Frameworks & Libraries
  'React': {
    path: '/icons/react.svg',
    name: 'React'
  },
  'Node.js': {
    path: '/icons/nodejs.svg',
    name: 'Node.js'
  },
  'Express': {
    path: '/icons/express.svg',
    name: 'Express'
  },
  'Pennylane': {
    path: '/icons/pennylane.svg',
    name: 'Pennylane'
  },
  'Next.js': {
    path: '/icons/nextjs.svg',
    name: 'Next.js'
  },

  // AI & ML
  'TensorFlow': {
    path: '/icons/tensorflow.svg',
    name: 'TensorFlow'
  },
  'PyTorch': {
    path: '/icons/pytorch.svg',
    name: 'PyTorch'
  },
  'scikit-learn': {
    path: '/icons/scikit-learn.svg',
    name: 'scikit-learn'
  },

  // Cloud & DevOps
  'AWS': {
    path: '/icons/aws.svg',
    name: 'AWS'
  },
  'Azure': {
    path: '/icons/azure.svg',
    name: 'Azure'
  },
  'Docker': {
    path: '/icons/docker.svg',
    name: 'Docker'
  },
  'Kubernetes': {
    path: '/icons/kubernetes.svg',
    name: 'Kubernetes'
  },
  'CI/CD': {
    path: '/icons/cicd.svg',
    name: 'CI/CD'
  },
  

  // Databases
  'MongoDB': {
    path: '/icons/mongodb.svg',
    name: 'MongoDB'
  },
  'PostgreSQL': {
    path: '/icons/postgresql.svg',
    name: 'PostgreSQL'
  },
  'Redis': {
    path: '/icons/redis.svg',
    name: 'Redis'
  },

  // Data Engineering
  'Apache Spark': {
    path: '/icons/spark.svg',
    name: 'Apache Spark'
  },
  'Kafka': {
    path: '/icons/kafka.svg',
    name: 'Kafka'
  },
  'Airflow': {
    path: '/icons/airflow.svg',
    name: 'Airflow'
  },

  // Tools & Others
  'Git': {
    path: '/icons/git.svg',
    name: 'Git'
  },
  'Jenkins': {
    path: '/icons/jenkins.svg',
    name: 'Jenkins'
  },
  'Grafana': {
    path: '/icons/grafana.svg',
    name: 'Grafana'
  },
  'CSS': {
    path: '/icons/css.svg',
    name: 'CSS'
  },
  'HTML': {
    path: '/icons/html.svg',
    name: 'HTML'
  },
  'Databricks': {
    path: '/icons/databricks.svg',
    name: 'Databricks'
  }
};

export const getTechIcon = (techName: string): TechIcon => {
  return techIcons[techName] || {
    path: '/icons/default.svg',
    name: techName
  };
};

export default techIcons; 